import React from "react";

import { getFlag } from "../reducers/persist";
import { useSelector } from "../utils/types";

import { lazyBundle } from "./Utils";

const ClockLazy = lazyBundle("Clock");

export default function ClockContainer() {
    const show = useSelector(store => getFlag(store, "perf_clock"));
    return show ? <ClockLazy /> : null;
}
